// avstemming-bank-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'avab.flag.notBooked': 'No contabilizada',
  'avab.flag.manualReview': 'Pendiente de revisión manual',
  'avab.flag.missingVoucher': 'Falta justificante',
  'avab.flag.possibleDuplicate': 'Posible duplicado',
  'avab.assess.notAssessed': 'Sin evaluar',
  'avab.assess.noCorrection': 'No requiere corrección',
  'avab.assess.transit': 'Diferencia temporal con el banco',
  'avab.assess.missingBooking': 'Contabilización faltante',
  'avab.assess.wrongBooking': 'Contabilización errónea — debe corregirse',
  'avab.assess.duplicate': 'Duplicado',
  'avab.assess.internalTransfer': 'Transferencia interna',
  'avab.assess.bankFee': 'Comisión bancaria',
  'avab.assess.interest': 'Intereses',
  'avab.assess.currencyDifference': 'Diferencia de cambio',
  'avab.assess.wrongBankAccount': 'Cuenta bancaria incorrecta',
  'avab.assess.shouldReverse': 'La contabilización debe revertirse',
  'avab.assess.awaitingDocs': 'Pendiente de documentación',
  'avab.assess.awaitingClient': 'Pendiente del cliente',
  'avab.assess.nextPeriod': 'Dar seguimiento el próximo periodo',
  'avab.nav.overview': 'Resumen',
  'avab.nav.accounts': 'Cuentas bancarias',
  'avab.nav.accountsCount': '{ok}/{total} cuadran',
  'avab.nav.transactions': 'Movimientos',
  'avab.nav.openCount': '{count} abiertos',
  'avab.nav.documentation': 'Documentación',
  'avab.nav.missingCount': '{count} faltan',
  'avab.nav.complete': 'Completa',
  'avab.nav.deviations': 'Desviaciones y medidas',
  'avab.nav.controls': 'Revisión y aprobación',
  'avab.noReconciliationAccount': 'La cuenta bancaria no tiene cuenta de conciliación en este periodo.',
  'avab.bank': 'Banco',
  'avab.activeAccount': 'Cuenta bancaria: {name}',
  'avab.showAllAccounts': 'Mostrar todas las cuentas bancarias',
  'avab.resetFilters': 'Restablecer filtros',
  'avab.common.description': 'Descripción',
  'avab.common.bankDate': 'Fecha bancaria',
  'avab.common.bookingDate': 'Fecha de contabilización',
  'avab.common.voucher': 'Justificante',
  'avab.common.bankAmount': 'Importe bancario',
  'avab.common.bookedAmount': 'Importe contabilizado',
  'avab.common.difference': 'Diferencia',
  'avab.common.assessment': 'Evaluación',
  'avab.common.close': 'Cerrar',
  'avab.tx.colMatch': 'Coincidencia',
  'avab.tx.colFlag': 'Aviso',
  'avab.tx.noFlags': 'Ninguno',
  'avab.tx.assess': 'Evaluar',
  'avab.tx.viewAssessment': 'Ver evaluación',
  'avab.tx.noMatchingLines': 'Ninguna línea bancaria coincide con los filtros.',
  'avab.tx.noStatement': 'Ningún extracto bancario cubre este periodo. Sin base bancaria no se puede conciliar el banco.',
  'avab.drawer.noBankMatch': 'Sin coincidencia bancaria',
  'avab.drawer.matchStatus': 'Estado de coincidencia',
  'avab.drawer.attachment': 'Adjunto',
  'avab.drawer.reasonRequired': 'Justificación (obligatoria)',
  'avab.drawer.reason': 'Justificación',
  'avab.drawer.reasonPlaceholder': '¿Qué muestra la revisión de esta línea?',
  'avab.drawer.action': 'Medida',
  'avab.drawer.actionPlaceholder': 'Ej. Investigar o revertir',
  'avab.drawer.followUpDue': 'Fecha límite de seguimiento',
  'avab.drawer.followUpNote': 'La línea aparecerá como propuesta de seguimiento en «Conclusión y aprobación».',
  'avab.drawer.needsReason': 'Esta evaluación requiere una justificación.',
  'avab.drawer.save': 'Guardar evaluación',
  'avab.drawer.askClient': 'Pedir documentación al cliente',
  'avab.common.account': 'Cuenta',
  'avab.common.date': 'Fecha',
  'avab.common.type': 'Tipo',
  'avab.common.amount': 'Importe',
  'avab.common.status': 'Estado',
  'avab.sections.responsible': 'Responsable {name}',
  'avab.sections.title': 'Banco – libro mayor frente al banco',
  'avab.sections.noAccounts': 'No hay cuentas bancarias configuradas para la conciliación',
  'avab.sections.unassessed': '{count} partidas bancarias requieren evaluación antes de poder enviar la conciliación a revisión.',
  'avab.sections.noneUnassessed': 'No quedan partidas bancarias por evaluar.',
  'avab.sections.notLinked': 'Ninguna de las cuentas bancarias está vinculada a una cuenta del libro mayor en este periodo. Sin el vínculo no hay líneas del libro mayor con las que comparar la base bancaria: la comprobación no se ha ejecutado, no es que no haya encontrado nada. El vínculo se configura en Ajustes.',
  'avab.cur.title': 'Cuentas en moneda extranjera',
  'avab.cur.none': 'Ninguna de las cuentas bancarias de la empresa está en moneda extranjera. Por tanto, no hay conversión que comprobar.',
  'avab.cur.noLedgerAccount': 'La cuenta bancaria no tiene cuenta del libro mayor en este periodo.',
  'avab.cur.intro': 'El banco informa del saldo en la moneda de la cuenta y el libro mayor lo lleva en coronas. La diferencia entre ambos es una conversión, no una desviación en la base bancaria.',
  'avab.cur.bankBalance': 'Saldo bancario',
  'avab.cur.rate': 'Tipo de cambio {date}',
  'avab.cur.converted': 'Convertido',
  'avab.cur.booked': 'Contabilizado',
  'avab.cur.conversionDifference': 'Diferencia de conversión',
  'avab.cur.noted': 'Cotizado el {date}',
  'avab.cur.noRate': 'Sin tipo de cambio cotizado',
  'avab.cur.fetchRate': 'Obtener tipo de cambio',
  'avab.cur.explained': 'Explicada',
  'avab.cur.explain': 'Explicar la conversión',
  'avab.cur.footnote': 'El tipo de cambio es la cotización de Norges Bank. La diferencia de conversión se contabiliza como ganancia o pérdida de cambio no realizada: la conciliación la muestra, pero no la contabiliza.',
  'avab.transit.title': 'Contabilizado sin coincidencia bancaria',
  'avab.transit.allMatched': 'Todas las contabilizaciones de las cuentas bancarias se han encontrado en el extracto bancario. Ninguna partida está esperando al banco.',
  'avab.transit.intro': 'Asientos de las cuentas bancarias que no se han encontrado en el extracto bancario. La coincidencia es una propuesta (mismo importe en un plazo de seis días), no una decisión contable.',
  'avab.transit.kpiItems': 'Partidas sin coincidencia bancaria',
  'avab.transit.kpiNeedsAssessment': '{count} requieren evaluación',
  'avab.transit.kpiItemsHint': 'Contabilizaciones de las cuentas bancarias sin una línea bancaria correspondiente.',
  'avab.transit.kpiNormal': 'Diferencia temporal normal',
  'avab.transit.kpiNormalHint': 'Contabilizado hasta 30 días antes del cierre del periodo: el pago aún puede estar en camino.',
  'avab.transit.kpiOld': 'Con más de 30 días',
  'avab.transit.kpiOldHint': 'Demasiado antiguo para ser una diferencia temporal. Debe investigarse o revertirse.',
  'avab.transit.kpiTotal': 'Importe total',
  'avab.transit.kpiTotalHint': 'El importe que estos asientos suponen de la diferencia con el banco.',
  'avab.transit.colAge': 'Antigüedad',
  'avab.transit.days': '{count} días',
  'avab.transit.needsAssessment': 'Requiere evaluación',
  'avab.transit.timingDifference': 'Diferencia temporal con el banco',
  'avab.int.title': 'Transferencias internas',
  'avab.int.none': 'Ningún justificante del periodo afecta a dos cuentas bancarias propias de la empresa.',
  'avab.int.offOne': '{count} transferencia no cuadra. La diferencia suele ser una comisión que el banco dedujo por el camino o una conversión entre cuentas de distinta moneda; ambas deben contabilizarse.',
  'avab.int.offMany': '{count} transferencias no cuadran. La diferencia suele ser una comisión que el banco dedujo por el camino o una conversión entre cuentas de distinta moneda; ambas deben contabilizarse.',
  'avab.int.allOk': 'Todas las transferencias entre cuentas bancarias propias de la empresa cuadran.',
  'avab.int.colFrom': 'Desde',
  'avab.int.colTo': 'Hasta',
  'avab.int.colOut': 'Salida',
  'avab.int.colIn': 'Entrada',
  'avab.int.deviation': 'Desviación',
  'avab.int.checked': 'Revisada',
  'avab.fees.title': 'Comisiones e intereses bancarios',
  'avab.fees.none': 'Ningún justificante del periodo registra comisiones o intereses en las cuentas bancarias. Una comisión que el banco ha deducido y no está contabilizada aparece como línea bancaria no contabilizada en la lista de movimientos.',
  'avab.fees.intro': 'Obtenido del libro mayor: justificantes que afectan a una cuenta bancaria y a una cuenta de comisiones o intereses. Las comisiones que el banco ha deducido y no están contabilizadas aparecen como líneas bancarias no contabilizadas en la lista de movimientos.',
  'avab.fees.colCount': 'Cantidad',
  'avab.fees.sum': 'Total',
  'avab.fees.items': 'Las partidas',
  'avab.fees.colText': 'Texto',
  'avab.fees.kind.fee': 'Comisión',
  'avab.fees.kind.interestIncome': 'Ingresos por intereses',
  'avab.fees.kind.interestExpense': 'Gasto por intereses',
  'avab.quick.requiresAssessment': 'Requieren evaluación',
  'avab.quick.all': 'Todas',
  'avab.quick.matched': 'Con coincidencia',
  'avab.quick.suggested': 'Coincidencia propuesta',
  'avab.quick.manualReview': 'Para revisión manual',
  'avab.quick.unmatchedBank': 'Banco sin coincidencia',
  'avab.quick.notBooked': 'No contabilizadas',
  'avab.quick.missingVoucher': 'Falta justificante',
  'avab.quick.possibleDuplicates': 'Posibles duplicados',
  'avab.quick.held': 'Excluidas',
  'avab.quick.assessed': 'Evaluadas',
  'avab.bal.title': 'Conciliación automática de saldos',
  'avab.bal.noComparable': 'Ninguna cuenta se puede comparar',
  'avab.bal.settledBadge': 'Saldo conciliado tras las partidas en tránsito',
  'avab.bal.unexplainedBadge': 'Diferencia sin explicar',
  'avab.bal.noComparableText': 'Ninguna cuenta bancaria tiene a la vez saldo contabilizado y saldo bancario en este periodo. Sin ambos lados no hay diferencia que conciliar.',
  'avab.bal.bookedAll': 'Saldo contabilizado, todas las cuentas bancarias',
  'avab.bal.bankPerDate': 'Saldo según el banco a {date}',
  'avab.bal.preliminary': 'Diferencia preliminar',
  'avab.bal.bookedWithoutMatch': 'Contabilizado sin coincidencia bancaria',
  'avab.bal.unexplained': 'Diferencia sin explicar',
  'avab.bal.settledText': 'El saldo contabilizado y el saldo bancario se pueden conciliar tras {amount} en asientos que aún no se han encontrado en el banco. Cada uno de ellos debe seguir evaluándose.',
  'avab.bal.unexplainedText': '{amount} de la diferencia no se explica por partidas en tránsito y debe investigarse.',
  'avab.bal.excluded': '{count} cuenta queda fuera de la comparación: cuenta en moneda extranjera o falta de base bancaria.',
  'avab.bal.previousBalance': 'Saldo del periodo anterior',
  'avab.bal.change': 'Variación en el periodo',
  'avab.bal.bankTransactions': 'Movimientos bancarios',
  'avab.bal.bookedTransactions': 'Movimientos bancarios contabilizados',
  'avab.bal.notBooked': 'No contabilizados',
  'avab.bal.coverageComplete': 'Base bancaria completa',
  'avab.bal.coveredOf': '{covered} de {total}',
  'avab.bal.basisNote': 'La base son los extractos bancarios que cubren de {from} a {to} y el balance de comprobación del mismo periodo.',
  'avab.cov.title': 'Cobertura documental por cuenta bancaria',
  'avab.cov.incompleteOne': 'La base bancaria no cubre todo el periodo en {count} cuenta bancaria.',
  'avab.cov.incompleteMany': 'La base bancaria no cubre todo el periodo en {count} cuentas bancarias.',
  'avab.cov.colBankAccount': 'Cuenta bancaria',
  'avab.cov.colFrom': 'Fecha desde',
  'avab.cov.colTo': 'Fecha hasta',
  'avab.cov.colCoverage': 'Cobertura',
  'avab.cov.colSource': 'Origen',
  'avab.cov.noStatement': 'Sin extracto',
  'avab.cov.incomplete': 'Incompleta',
  'avab.cov.requestStatement': 'Solicitar extracto de cuenta de {account}',
  'avab.ctl.ledgerVsBank': 'Libro mayor frente al banco',
  'avab.ctl.settledOf': '{settled} de {total} conciliadas',
  'avab.ctl.ledgerVsBankHint': 'Saldo contabilizado comparado con el saldo bancario de cada cuenta bancaria.',
  'avab.ctl.unbookedLines': 'Líneas bancarias no contabilizadas',
  'avab.ctl.unbookedLinesHint': 'Líneas bancarias sin la contabilización correspondiente.',
  'avab.ctl.olderThan30': '{count} con más de 30 días',
  'avab.ctl.noMatchHint': 'Asientos de las cuentas bancarias que no se han encontrado en el extracto bancario.',
  'avab.ctl.manualHint': 'Líneas bancarias que la vista de banco ha marcado para revisión manual.',
  'avab.ctl.duplicateHint': 'Misma cuenta, fecha, importe y texto.',
  'avab.ctl.missingDocs': 'Documentación faltante',
  'avab.ctl.bankAccountOne': 'cuenta bancaria',
  'avab.ctl.bankAccountMany': 'cuentas bancarias',
  'avab.ctl.missingDocsHint': 'Cuenta bancaria con cobertura del periodo incompleta.',
  'avab.ctl.missingVoucherHint': 'Pagos sin adjunto, sin exención y sin que el extracto bancario esté aprobado como justificante.',
  'avab.ctl.internalDeviations': 'Transferencias internas con desviaciones',
  'avab.ctl.internalDeviationsHint': 'Transferencias entre cuentas bancarias propias de la empresa que no cuadran.',
  'avab.ctl.feeItems': 'Partidas de comisiones e intereses',
  'avab.ctl.feeItemsHint': 'Justificantes que afectan a una cuenta bancaria y a una cuenta de comisiones o intereses.',
  'avab.ctl.foreignHint': 'Cuentas cuyo saldo bancario debe convertirse antes de poder compararlo.',
  'avab.ctl.linesInPeriod': 'Líneas bancarias del periodo',
  'avab.ctl.linesInPeriodHint': 'Todas las líneas de la base bancaria del periodo.',
  'avab.ctl.bookedLines': 'Líneas bancarias contabilizadas',
  'avab.ctl.bookedLinesHint': 'Líneas bancarias emparejadas con una contabilización.',
  'avab.ctl.title': 'Tarjeta de control',
  'avab.ctl.summary': 'Comprobaciones automáticas ejecutadas: {run} de {total} · Comprobaciones con hallazgos: {findings} · Partidas con aviso: {flagged}',
  'avab.ctl.hide': 'Ocultar',
  'avab.ctl.showAll': 'Mostrar todas las comprobaciones automáticas',
  'avab.ctl.activeFilter': 'Filtro activo: {flag} · {count} partidas',
  'avab.ctl.removeFilter': 'Quitar filtro',
  'avab.checks.title': 'Comprobaciones automáticas',
  'avab.checks.intro': 'Las comprobaciones no marcan nada en la lista de comprobación profesional. Indican qué debería haber revisado quien la marca.',
  'avab.checks.colCheck': 'Comprobación',
  'avab.checks.colRun': 'Ejecución',
  'avab.checks.colFindings': 'Hallazgos',
  'avab.checks.run': 'Ejecutada',
  'avab.checks.findings': '{count} hallazgos',
  'avab.checks.noFindings': 'Sin hallazgos',
  'avab.match.title': 'Resumen de coincidencias',
  'avab.match.remainingOne': 'El {pct} % de las partidas del periodo está vinculado. Queda {count} partida.',
  'avab.match.remainingMany': 'El {pct} % de las partidas del periodo está vinculado. Quedan {count} partidas.',
  'avab.acc.status.currency': 'La moneda debe revisarse',
  'avab.acc.notCompared': 'Sin comparar',
  'avab.acc.status.agrees': 'Cuadra',
  'avab.acc.status.reconciled': 'Conciliada',
  'avab.acc.intro': 'Haz clic en una fila para filtrar toda la vista a esa cuenta bancaria.',
  'avab.acc.colCurrency': 'Moneda',
  'avab.acc.colBookedBalance': 'Saldo contabilizado',
  'avab.acc.colExplained': 'Explicada',
  'avab.acc.colUnexplained': 'Sin explicar',
  'avab.acc.lineCount': '{count} líneas',
  'avab.acc.requiresConversion': 'Requiere conversión',
  'avab.acc.incompleteBasis': 'Base bancaria incompleta',
  'avab.acc.openAccount': 'Abrir cuenta',
  'avab.acc.noAccounts': 'La empresa no tiene cuentas bancarias configuradas para la conciliación. Las cuentas se configuran en Ajustes.',
  'avab.derived.notBooked': 'Las líneas bancarias no contabilizadas están tratadas',
  'avab.derived.manualReview': 'Las líneas bancarias para revisión manual están tratadas',
  'avab.derived.missingVoucher': 'Los pagos sin justificante están tratados',
  'avab.derived.possibleDuplicate': 'Los posibles duplicados están evaluados',
  'avab.chk.title': 'Lista de comprobación profesional',
  'avab.chk.titleReadOnly': 'Lista de comprobación profesional (de quien la realiza, solo lectura)',
  'avab.chk.noItems': 'No hay puntos de control definidos para el banco en este periodo.',
  'avab.chk.intro': 'Los puntos afectan a toda el área de banco. Cada marca se guarda en todas las cuentas bancarias del periodo.',
  'avab.chk.groupItems': 'Partidas que requieren tratamiento',
  'avab.chk.countOf': '{done} de {total}',
  'avab.chk.processedOf': '{done} de {total} tratadas',
  'avab.chk.notApplicable': 'No aplica este periodo',
  'avab.chk.followsAssessments': 'Se deriva de las evaluaciones',
  'avab.chk.groupAssessments': 'Evaluaciones profesionales generales',
  'avab.chk.groupReady': 'Preparación final',
  'avab.chk.performedBy': 'Realiza {name}',
  'avab.chk.completedOf': '{done} de {total} puntos de control completados',
  'avab.blk.linesOne': '{count} línea bancaria requiere evaluación',
  'avab.blk.linesMany': '{count} líneas bancarias requieren evaluación',
  'avab.blk.unexplained': '{amount} de la diferencia con el banco está sin explicar',
  'avab.blk.coverageOne': '{count} cuenta bancaria tiene la base bancaria incompleta',
  'avab.blk.coverageMany': '{count} cuentas bancarias tienen la base bancaria incompleta',
  'avab.blk.staleOne': '{count} contabilización sin coincidencia bancaria tiene más de 30 días',
  'avab.blk.staleMany': '{count} contabilizaciones sin coincidencia bancaria tienen más de 30 días',
  'avab.blk.checklistOne': 'Queda {count} punto de control',
  'avab.blk.checklistMany': 'Quedan {count} puntos de control',
  'avab.concl.title': 'Conclusión y aprobación',
  'avab.concl.label': 'Conclusión',
  'avab.concl.placeholder': '¿Qué muestra la revisión del banco en este periodo?',
  'avab.concl.note': 'Se guarda como justificación del punto de control «{label}».',
  'avab.concl.remainingRisk': 'Riesgo restante',
  'avab.concl.nothingLeft': 'No queda nada que impida enviar el área a revisión.',
  'avab.concl.followUp': 'Seguimiento del próximo periodo',
  'avab.concl.noFollowUps': 'Ninguna evaluación está marcada para seguimiento el próximo periodo.',
  'avab.concl.followedUp': 'En seguimiento',
  'avab.concl.action': 'Medida: {action}',
  'avab.concl.noAction': 'Sin medida anotada',
  'avab.concl.deadline': 'Plazo {date}',
  'avab.concl.openAssessment': 'Abrir evaluación',
  'avab.concl.sendToControl': 'Enviar el área a revisión',
  'avab.concl.oneLeft': 'Queda una cosa antes de poder enviar el área.',
  'avab.concl.manyLeft': 'Quedan {count} cosas antes de poder enviar el área.',
});
